import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { categories } from "@/mocks/videoData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </span>
            <span className="text-xl font-bold text-foreground-950">苹果视频</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/"
                  ? "text-primary-500 bg-primary-100"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? "text-primary-500 bg-primary-100"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/about"
                  ? "text-primary-500 bg-primary-100"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <button className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-700 text-lg"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-foreground-700 text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}